var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  ref: "cusChatTable",
                  staticStyle: { "font-size": "13px" },
                  attrs: {
                    size: "small",
                    data: _vm.tableData,
                    fit: "",
                    "highlight-current-row": "",
                    align: "center",
                    "header-cell-style": { background: "#F9F9F9" },
                    height: "calc(60vh - 2px)"
                  },
                  on: { "row-click": _vm.handleclick }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "externalName",
                      label: "客户信息",
                      "min-width": "150"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "wordName",
                      label: "敏感词",
                      "min-width": "150"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "触发时间",
                      "min-width": "150"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "聊天记录", "min-width": "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "content-record",
                                staticStyle: { color: "#1F74E1" }
                              },
                              [_vm._v(_vm._s(scope.row.content))]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("Pagination", {
        attrs: { childMsg: _vm.pageparm, pageSizes: _vm.pageSizes },
        on: { callBack: _vm.callBack }
      }),
      _c(
        "el-dialog",
        {
          ref: "dia",
          staticClass: "chat-content-dialog",
          attrs: {
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "modal-append-to-body": false,
            "append-to-body": "",
            width: "600px",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            },
            open: _vm.open
          }
        },
        [
          _c(
            "div",
            { staticClass: "content-container" },
            [_c("SenWordChatCommon", { ref: "SenWordChatCommon" })],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }